import React from 'react';

const Logo = () => {
  return (
    <div style={{ 
      fontSize: '1.5rem',
      fontWeight: 800,
      color: '#000',
      textAlign: 'center',
      paddingTop: '2rem',
      marginBottom: '1rem'
    }}>
      Legal<span style={{ fontWeight: 400 }}>HDM</span>
    </div>
  );
};

export default Logo; 